import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function SaginawPage() {
  const location = getLocationById('saginaw');
  if (!location) {
    return <div data-id="element-814">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-815">
      <Header data-id="element-816" />

      <main className="pt-20" data-id="element-817">
        <LocationPageHero location={location} data-id="element-818" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-819" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-820" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-821" />
      </main>

      <Footer data-id="element-822" />
    </div>;
}